import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash-es';

@Injectable()

@Pipe({
    name: 'orderByCloth', pure: false,
    standalone: true
})

export class OrderByCloth implements PipeTransform {
  // array - array
  // config - parameter
  // order - asc / desc

  transform<T extends { cloth_number: number }>(array: T[], params: any, order?: any): T[] {
    const ordered = _.orderBy(array, params, order);
    const tmp: T[] = [];
    const tmpNegative: T[] = [];

    _.map(ordered, function (item: T) {
      if (item.cloth_number < 0) {
        tmpNegative.push(item);
      } else {
        tmp.push(item);
      }
    });
    // tmp = _.reverse(tmp);
    return tmp.concat(tmpNegative);
  }
}
